import { OnInit, ElementRef, OnChanges, EventEmitter } from '@angular/core';
import { ModalService } from './modal.service';
import { ModalConfig } from 'app/shared/models/modalConfig.model';
import { DomHelper } from '@sc/pas-common';
import { KeyCode } from 'app/shared/models/keycode';
var ModalComponent2 = /** @class */ (function () {
    function ModalComponent2(modalService, dom) {
        this.modalService = modalService;
        this.dom = dom;
        this.blocking = false;
        this.options = new ModalConfig();
        this.onModalClose = new EventEmitter();
        this.modalContainer = ElementRef;
        this.isOpen = false;
        this.isRegistered = false;
    }
    ModalComponent2.prototype.onMouseEnter = function (event) {
        this.keyup(event);
    };
    ModalComponent2.prototype.ngOnChanges = function (change) {
        var _this = this;
        if (this.modalContainer && this.modalContainer['nativeElement']) {
            this.buttonsBox = this.modalContainer['nativeElement'].getElementsByClassName('modal__buttonsBox')[0];
            this.buttonsBox.innerHTML = '';
            if (this.options && this.options.buttons && this.buttonsBox) {
                if (this.options.buttons.length) {
                    this.dom.addClass(this.buttonsBox, 'modal__buttonsBox-' + this.options.buttons.length);
                }
                this.options.buttons.forEach(function (b) {
                    var btn = document.createElement('button');
                    _this.dom.addClass(btn, 'modal__button btn');
                    if (b.className) {
                        _this.dom.addClass(btn, b.className);
                    }
                    if (b.id) {
                        btn.id = b.id;
                    }
                    if (b.default || _this.options.buttons.length === 1) {
                        _this.dom.addClass(btn, 'default');
                    }
                    btn.innerHTML = b.text;
                    if (b.cancel) {
                        btn.onclick = function () {
                            _this.close();
                        };
                    }
                    else {
                        if (b.action) {
                            btn.onclick = b.action;
                        }
                    }
                    _this.buttonsBox.append(btn);
                });
            }
            if (!this.isRegistered) {
                this.isRegistered = true;
                this.isOpen = false;
                this.modalService.registerModal(this);
            }
            else {
                this.isOpen = true;
            }
        }
        this.sizeClass = (this.options && this.options.size) ? "modal--" + this.options.size : '';
        this.contentPadding = (this.options && this.options.closeButton) ? '53px' : '38px';
    };
    ModalComponent2.prototype.ngOnInit = function () {
    };
    ModalComponent2.prototype.close = function (checkBlocking) {
        if (checkBlocking === void 0) { checkBlocking = false; }
        if (this.id && !checkBlocking) {
            this.onModalClose.emit(true);
            this.modalService.close(this.id, checkBlocking);
        }
    };
    ModalComponent2.prototype.keyup = function (event) {
        if (event) {
            if (event.keyCode === KeyCode.Escape) {
                this.modalService.close(this.id, true);
            }
            if (event.keyCode === KeyCode.Enter) {
                var defaultBtn = this.buttonsBox[0].getElementsByClassName('default');
                defaultBtn[0].click();
            }
        }
    };
    return ModalComponent2;
}());
export { ModalComponent2 };
